import * as React from 'react';
import ErrorHint from '../common/ErrorHint';
import { DatePickerProps } from '../types/DatePickerProps';

export const DatePickerMobile: React.FC<DatePickerProps> = ({
  title,
  value,
  error,
  updateHandler,
  blurHandler,
}: DatePickerProps) => {
  const borderColorClassName = error
    ? 'border-red-500'
    : 'border-gray-200 focus:border-green-500 dark:border-dark-input-background dark:focus:border-dark-green';

  const bgClassName = error
    ? 'bg-white dark:bg-dark-input-background'
    : 'bg-gray-200 dark:bg-dark-input-background dark:focus:bg-dark-background';

  return (
    <div className="w-full text-left rtl:text-right">
      <label
        htmlFor={title}
        className="text-black dark:text-dark-content-primary font-bold text-sm text-left rtl:text-right"
      >
        {title}
      </label>
      <div className="h-12 rounded border-none w-full my-2">
        <input
          id={title}
          className={`outline-none h-12 rounded border-2 focus:bg-white ${borderColorClassName} ${bgClassName} px-3 w-full${
            value ? ' has-value' : ''
          }`}
          type="date"
          defaultValue={value === null ? '' : value}
          onInput={(e) => updateHandler((e.target as HTMLInputElement).value)}
          onBlur={(e) => blurHandler(e)}
        />
        <ErrorHint error={error} />
      </div>
    </div>
  );
};
